import API from "./api";

const CourseService = {
  // Get all courses
  getAllCourses: async () => {
    try {
      const response = await API.get("/courses");
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get single course
  getCourseById: async (id) => {
    try {
      const response = await API.get(`/courses/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Create course with files (image + syllabus)
  createCourseWithFiles: async (formData) => {
    try {
      const response = await API.post("/courses", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update course with files (image + syllabus)
  updateCourseWithFiles: async (id, formData) => {
    try {
      const response = await API.put(`/courses/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Delete course (admin only)
  deleteCourse: async (id) => {
    try {
      const response = await API.delete(`/courses/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get enrolled students in a course
  getEnrolledStudents: async (courseId) => {
    try {
      const response = await API.get(`/courses/${courseId}/students`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Student self-enroll
  enrollInCourse: async (courseId) => {
    try {
      const response = await API.post(`/courses/${courseId}/enroll`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Download syllabus
  downloadSyllabus: async (courseId) => {
    try {
      const response = await API.get(`/courses/${courseId}/syllabus`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];
      let filename = "syllabus.pdf";
      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
        );
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1].replace(/['"]/g, "");
        }
      }

      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw error;
    }
  },

  // Get available students for a course
  getAvailableStudentsForCourse: async (courseId) => {
    try {
      const response = await API.get(`/courses/${courseId}/available-students`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // UPDATED: Add new student manually to course with custom fee
  addStudentManuallyToCourse: async (courseId, studentData) => {
    try {
      const response = await API.post(
        `/courses/${courseId}/students/manual`,
        studentData,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // UPDATED: Add existing student to course with custom fee
  addExistingStudentToCourse: async (courseId, studentId, customFee) => {
    try {
      const response = await API.post(
        `/courses/${courseId}/students/${studentId}`,
        { custom_fee: customFee },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get courses for adoption (exclude current course)
  getCoursesForAdoption: async (excludeCourseId) => {
    try {
      const response = await API.get(
        `/courses/${excludeCourseId}/for-adoption`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CourseService;
